// @ts-nocheck
import { AlertCircle, AlertTriangle, CheckCircle, Info, X } from 'lucide-react';
import { useEffect } from 'react';

const Toast = ({ message, type = 'info', onClose, duration = 4000, onClick }) => {
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const icons = {
    success: <CheckCircle className="w-5 h-5" />,
    error: <AlertCircle className="w-5 h-5" />,
    warning: <AlertTriangle className="w-5 h-5" />,
    info: <Info className="w-5 h-5" />,
  };

  const styles = {
    success: 'bg-green-50 text-green-800 border-green-200 dark:bg-green-950 dark:text-green-200 dark:border-green-900',
    error: 'bg-red-50 text-red-800 border-red-200 dark:bg-red-950 dark:text-red-200 dark:border-red-900',
    warning:
      'bg-yellow-50 text-yellow-800 border-yellow-200 dark:bg-yellow-950 dark:text-yellow-200 dark:border-yellow-900',
    info: 'bg-blue-50 text-blue-800 border-blue-200 dark:bg-blue-950 dark:text-blue-200 dark:border-blue-900',
  };

  return (
    <div
      className={`fixed top-4 left-4 right-4 sm:left-auto sm:top-6 sm:right-6 z-50 flex items-center gap-3 px-4 py-3 rounded-lg border shadow-lg sm:max-w-sm md:max-w-md animate-slide-in ${styles[type]}`}
    >
      <div className="flex-shrink-0">{icons[type]}</div>
      {onClick ? (
        <button
          type="button"
          onClick={() => {
            onClick();
            onClose();
          }}
          className="flex-1 text-left text-sm font-medium underline-offset-2 hover:underline"
        >
          {message}
        </button>
      ) : (
        <p className="flex-1 text-sm font-medium">{message}</p>
      )}
      <button
        onClick={onClose}
        className="flex-shrink-0 p-2 -m-2 hover:opacity-70 transition-opacity focus:outline-none"
        aria-label="Close notification"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default Toast;
